import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { HEADER_SUBDOMAIN_OVERRIDE } from "@faire/web--source/common/consts/HEADER_SUBDOMAIN_OVERRIDE";
import { replaceSubdomain } from "@faire/web--source/common/replaceSubdomain";
import { getLocationOrigin } from "@faire/web--source/common/splitHostname";
import { isError } from "@faire/web--source/common/typescriptUtils";
import { IApiError } from "@faire/web-api--source/indigofair/data/IApiError";
import { WebApiError } from "@faire/web-api--source/WebApiError";
import { WebApiNetworkError } from "@faire/web-api--source/WebApiNetworkError";
import { WebApiRequestCancellationError } from "@faire/web-api--source/WebApiRequestCancellationError";
import { parseJson } from "../../string";
import { prefetchReaderFactory } from "./__internal__/prefetchReaderFactory";
var HTML_TAG_REGEXP = /<\s*html\s*>/i;
export var fetchRequestHandlerFactory = function fetchRequestHandlerFactory(customFetch) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(requestOptions) {
      var _requestOptions$baseU;
      var url, body, headers, includeCredentials, _includeCredentials, resp, credentials, requestInit, fetchFn, defaultError;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            url = new URL(requestOptions.url, (_requestOptions$baseU = requestOptions.baseUrl) !== null && _requestOptions$baseU !== void 0 ? _requestOptions$baseU : getLocationOrigin());
            body = requestOptions.data;
            headers = new Headers(requestOptions.headers);
            if (_typeof(body) === "object" && headers.get("content-type") === "application/json") {
              body = JSON.stringify(body);
            }
            if (body instanceof FormData && headers.get("content-type") === "multipart/form-data") {
              // Clear the content-type when sending form data over fetch
              // This stack overflow answer explains that the browser handles for us
              // https://stackoverflow.com/questions/35192841/how-do-i-post-with-multipart-form-data-using-fetch
              headers["delete"]("content-type");
            }
            includeCredentials = requestOptions.withCredentials;
            if (requestOptions.subdomain && requestOptions.subdomain !== "www") {
              url = new URL(url.href.replace(url.origin, ""), replaceSubdomain(url.origin, requestOptions.subdomain));
              // This header is required by the local dev proxy to override the subdomain
              headers.set(HEADER_SUBDOMAIN_OVERRIDE, requestOptions.subdomain);
              includeCredentials = (_includeCredentials = includeCredentials) !== null && _includeCredentials !== void 0 ? _includeCredentials : true;
            }
            if (requestOptions.params) {
              url.search = buildParams(url.search, requestOptions.params);
            }
            _context.prev = 8;
            credentials = "omit";
            if (includeCredentials === undefined) {
              credentials = "same-origin";
            } else if (includeCredentials) {
              credentials = "include";
            }
            requestInit = {
              method: requestOptions.method,
              body: body,
              headers: headers,
              signal: requestOptions.signal,
              credentials: credentials,
              cache: requestOptions.cache,
              redirect: requestOptions.redirect,
              next: requestOptions.next
            };
            fetchFn = customFetch !== null && customFetch !== void 0 ? customFetch : fetch;
            _context.next = 15;
            return fetchFn(url.toString(), requestInit);
          case 15:
            resp = _context.sent;
            _context.next = 25;
            break;
          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](8);
            if (!(isError(_context.t0) && _context.t0.name === "AbortError")) {
              _context.next = 22;
              break;
            }
            return _context.abrupt("return", {
              error: new WebApiRequestCancellationError()
            });
          case 22:
            defaultError = new WebApiNetworkError("Network Error");
            if (isError(_context.t0)) {
              defaultError.name = _context.t0.name;
              defaultError.message = "Network Error: ".concat(_context.t0.message);
              defaultError.stack = _context.t0.stack;
            }
            return _context.abrupt("return", {
              error: defaultError
            });
          case 25:
            return _context.abrupt("return", normalizeResponse(resp, requestOptions));
          case 26:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[8, 18]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
/**
 * Normalizes the response from the fetch request to the expected WebApiResponse
 */
export var normalizeResponse = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resp, requestOptions) {
    var httpStatusCode, statusText, responseHeaders, validRedirect, _resp$headers$get, _json, requestInfo, responseText, json, errorMessage;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          httpStatusCode = resp.status;
          statusText = resp.statusText;
          responseHeaders = Object.fromEntries(resp.headers.entries());
          validRedirect = resp.status >= 300 && resp.status < 400 && requestOptions.redirect === "manual";
          if (!(!resp.ok && !validRedirect)) {
            _context2.next = 11;
            break;
          }
          requestInfo = "".concat(requestOptions.method, " ").concat(resp.url.toString(), " ").concat(httpStatusCode, ": ").concat(statusText);
          _context2.next = 8;
          return resp.text();
        case 8:
          responseText = _context2.sent;
          if ((_resp$headers$get = resp.headers.get("content-type")) !== null && _resp$headers$get !== void 0 && _resp$headers$get.startsWith("application/json")) {
            try {
              json = parseJson(responseText);
            } catch (_unused) {
              errorMessage = resp.headers.get("content-type") === "text/html" || HTML_TAG_REGEXP.test(responseText) ? undefined : responseText;
              json = {
                message: errorMessage
              };
            }
          }
          return _context2.abrupt("return", {
            status: httpStatusCode,
            headers: responseHeaders,
            error: new WebApiError("".concat(requestInfo).concat((_json = json) !== null && _json !== void 0 && _json.message ? ": ".concat(json.message) : ""), httpStatusCode, IApiError.build(_objectSpread(_objectSpread({}, json), {}, {
              status_code: httpStatusCode,
              status_type: statusText
            })))
          });
        case 11:
          _context2.next = 13;
          return handleResponseType(resp, requestOptions.responseType);
        case 13:
          _context2.t0 = _context2.sent;
          _context2.t1 = httpStatusCode;
          _context2.t2 = responseHeaders;
          return _context2.abrupt("return", {
            data: _context2.t0,
            status: _context2.t1,
            headers: _context2.t2
          });
        case 17:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function normalizeResponse(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
var fetchHandler = fetchRequestHandlerFactory();
var handleResponseType = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(resp, responseType) {
    var _resp$headers$get2;
    var data, text;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          data = undefined;
          if (!(responseType === "json")) {
            _context3.next = 9;
            break;
          }
          _context3.t0 = JSON;
          _context3.next = 5;
          return resp.text();
        case 5:
          _context3.t1 = _context3.sent;
          data = _context3.t0.parse.call(_context3.t0, _context3.t1);
          _context3.next = 26;
          break;
        case 9:
          if (!(responseType === "text")) {
            _context3.next = 15;
            break;
          }
          _context3.next = 12;
          return resp.text();
        case 12:
          data = _context3.sent;
          _context3.next = 26;
          break;
        case 15:
          if (!(responseType === "blob")) {
            _context3.next = 21;
            break;
          }
          _context3.next = 18;
          return resp.blob();
        case 18:
          data = _context3.sent;
          _context3.next = 26;
          break;
        case 21:
          if (!((_resp$headers$get2 = resp.headers.get("content-type")) !== null && _resp$headers$get2 !== void 0 && _resp$headers$get2.startsWith("application/json"))) {
            _context3.next = 26;
            break;
          }
          _context3.next = 24;
          return resp.text();
        case 24:
          text = _context3.sent;
          try {
            data = JSON.parse(text);
          } catch (e) {
            // eslint-disable-next-line no-console
            console.error("Failed to parse JSON: ".concat(e));
            data = text;
          }
        case 26:
          return _context3.abrupt("return", data);
        case 27:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function handleResponseType(_x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}();
var buildParams = function buildParams(existingSearch, params) {
  var search = new URLSearchParams(existingSearch);
  for (var _i = 0, _Object$entries = Object.entries(params); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      k = _Object$entries$_i[0],
      v = _Object$entries$_i[1];
    if (v === undefined) {
      continue;
    }
    var all = Array.isArray(v) ? v : [v];
    var _iterator = _createForOfIteratorHelper(all),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var each = _step.value;
        search.append(k, each);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return search.toString();
};
export var requestHandler = prefetchReaderFactory(fetchHandler);